const AttachmentsActivity = () => require("@/components/forms/renderers/attachments/AttachmentsActivity");

/**
 * @param {[]} attachments
 * @param {string} title
 * @param {boolean?} editMode
 * @param {boolean?} readOnly
 * @param {ValidatedField?} validatedField
 * @param {Function?} attachmentUploadFunction
 * @param {Function?} attachmentSaveFunction
 * @return {Promise<>}
 *
 */
export async function editAttachmentsActivity(
    attachments,
    title,
    editMode=false,
    readOnly=false,
    validatedField = null,
    attachmentUploadFunction = null,
    attachmentSaveFunction = null)
{

    const activity = await ActivityManager.showActivity(AttachmentsActivity, {
        title,
        attachments,
        validatedField,
        canEdit: !readOnly,
        editMode: !readOnly && editMode,
        attachmentUploadFunction,
        attachmentSaveFunction
    });

    return activity.getResult();
}
